export const faqs = [
  {
    q: "契約前に現地確認と見積は無料ですか？",
    a: "はい、福岡エリアであれば現地確認・お見積とも無料です。ご相談から24時間以内を目安にご連絡差し上げます。",
  },
  {
    q: "1棟だけの小規模物件でも依頼できますか？",
    a: "もちろん可能です。当社は中小規模物件を得意としており、10戸未満のマンション・アパート・小規模ビルも数多くお引き受けしております。",
  },
  {
    q: "契約期間の縛りはありますか？",
    a: "最低契約期間は基本ございません。1回のスポット依頼から、月次・年次契約まで柔軟にお選びいただけます。",
  },
  {
    q: "支払方法を教えてください",
    a: "銀行振込が基本です。オーナー様のご事情に応じて調整も可能ですのでご相談ください。",
  },
  {
    q: "対応エリアを教えてください",
    a: "福岡市を中心に対応しております。エリア外もお気軽にご相談ください。",
  },
];